import accounting from "accounting";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import { FormControl } from "react-bootstrap";
import math from "mathjs";
import $ from "jquery";

export default class InputAmount extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			amount: this.props.value,
			amountString: +this.props.value ? `${this.props.value}` : "",
			hasError: false,
			isNull: this.props.allowNull && !this.props.value
		};

		this.handleBlur = this.handleBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
	}

	handleTextFieldChange(event)
	{
		const amountString = event.target.value || "";
		const state = { amountString, hasError: false }; // Clear error because they are trying
		try
		{
			const amountStringProcessed = amountString.replace(/,/g, "");
			state.isNull = this.props.allowNull && amountStringProcessed === "";
			state.amount = accounting.toFixed(math.eval(amountStringProcessed), this.props.numberDecimals);
		}
		catch (err)
		{
			// User is likely still typing, handle err on blur
		}

		this.setState(state, () =>
		{
			if (this.state.isNull)
			{
				this.props.onChange(null);
			}
			else if (state.hasOwnProperty("amount"))
			{
				this.props.onChange(+state.amount);
			}
		});
	}

	handleFocus(event)
	{
		this.props.onFocus(event);
	}

	handleBlur(event)
	{
		const amountString = this.state.amountString;
		let amount = this.state.amount;
		let encounteredError = false;
		try
		{
			// TODO: BUG187 would prefer to do something with regex rather than just removing all commas. handleTextFieldChange as well
			// There are complications with eval, example: 5,000+200.50
			//const digitEnforcer = /(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}/g;
			const amountStringProcessed = amountString.replace(/,/g, "");
			const isNull = this.props.allowNull && amountStringProcessed === "";
			amount = accounting.toFixed(math.eval(amountStringProcessed), this.props.numberDecimals);
			if (+amount !== +this.props.value)
			{
				this.props.onChange(+amount);
			}
			// Resolve amount string on blur
			this.setState({ amount, amountString: +amount ? amount : "", hasError: false, isNull });
		}
		catch (err)
		{
			event.preventDefault();
			event.stopPropagation();
			encounteredError = true;
			this.setState({ hasError: true }, () =>
			{
				$(ReactDOM.findDOMNode(this)).find(".form-control").focus();
			});
		}

		if (!encounteredError)
		{
			this.props.onBlur(event);
		}
	}

	handleKeyDown(event)
	{
		this.props.onKeyDown(event);
	}

	componentWillReceiveProps(nextProps)
	{
		if (+nextProps.value !== +this.state.amount)
		{
			const state = {
				amount: nextProps.value,
				amountString: +nextProps.value ? `${nextProps.value}` : "",
				isNull: nextProps.allowNull && !nextProps.value
			};
			this.setState(state);
		}
	}

	render()
	{
		const amountString = this.state.amountString;

		// TODO: might want to have a way for users to disable the inputMode in case they don't like it, or want to be able to use +-/*

		return (
			<div className={classNames({ "has-error": this.state.hasError })}>
				<FormControl
					type="text"
					inputMode={this.props.numberDecimals === 0 ? "numeric" : "decimal"}
					bsClass={classNames("form-control input-sm", { "text-right": this.props.pullRight }, this.props.className)}
					value={amountString}
					onChange={this.handleTextFieldChange}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
					onKeyDown={this.handleKeyDown}
				/>
			</div>
		);
	}
}

InputAmount.defaultProps = {
	pullRight: true,
	allowNull: false,
	numberDecimals: 2,
	onBlur: () => {},
	onFocus: () => {},
	onKeyDown: () => {},
	onChange: () => {}
};

InputAmount.propTypes = {
	className: PropTypes.string,
	value: PropTypes.number,
	numberDecimals: PropTypes.number,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyDown: PropTypes.func,
	pullRight: PropTypes.bool,
	allowNull: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/InputAmount.jsx